import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import refresh from './modules/refresh';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //是否登录
    isLogin: false,
    IM: null,//im通讯实例
    userInfo: {
      userType: '2',
    },//当前的用户信息
    roomInfo: {
      status: 1,
    },//房间信息
    TEFn: {
      name: '',
      data: null
    },//TE白板页面中的方法,执行白板页面中的方法
    IMFn: {
      name: '',
      data: null
    },//IM通讯页面中的方法,执行IM页面中的方法
    TRTCFn: {
      name: '',
      data: null
    },//TRTC页面中的方法,执行IM页面中的方法
    membersFn: {
      name: '',
      data: null
    },//管理成员页面中的方法
    tabDataFn: {
      name: '',
      data: null
    },//资料页面里面的方法
    tabQuesFn: {
      name: '',
      data: null
    },//问卷页面里面的方法
    videoUserList: [],//拥有视频流用户的人
    questionnaireList:[],//问卷列表
    informationList:[],//资料列表
    IMStatus: [],
    TRTCStatus: [],
    isShareScreen: false, //当前的开启分享桌面的状态,默认没有开始

    meetingConfig: {},//房间默认配置
    meetingInfo: {},//房间信息
    conferee: {},//当前参会人信息
    confereeCurrentStatus: {},//当前参会人状态
    meetingCurrentStatus: {},//当前房间状态

    meetingLayoutConfigList: {},//会议布局设置列表
    meetingSenceConfigList: {},//会议场景布局设置
    locaLayoutConfig: {},//用户当前选择的布局设置信息
    sdkAppId: '',//im trtc te
    mcuMixTranscodeUrl:'',// 推流播放地址
    tipsFlag:false, //提醒问卷填写开关
    surveyCodeList:[], //提醒打开问卷数组
    screenShareStream: null, //屏幕分享流实例
    allowGenerator: false
  },
  getters,
  actions,
  mutations,
  modules: {
    refresh
  }
});

if (module.hot) {
  // 使 action 和 mutation 成为可热重载模块
  module.hot.accept(['./mutations', './modules/refresh'], () => {
    // 获取更新后的模块
    // 因为 babel 6 的模块编译格式问题，这里需要加上 `.default`
    const newMutations = require('./mutations').default
    const refresh = require('./modules/refresh').default
    // 加载新模块
    store.hotUpdate({
      mutations: newMutations,
      modules: {
        refresh: refresh
      }
    })
  })
}




// 服务器, 2: 服务器收到创建截图的任务, 会下发im截图指令给主讲人

// 4, 服务器收到主讲人的截图后, 再把截图发给点击生成截图的人(主持人, 小助手, 所有者);



// 观众1,: 3, 收到im截图指令, 截图之后, 调用api接口将截图发给服务器 //
// 观众2,: 3, 收到im截图指令, 截图之后, 调用api接口将截图发给服务器 //
// 观众3,: 3, 收到im截图指令, 截图之后, 调用api接口将截图发给服务器 //






// 主持人, 1, 点击生成截图(a: 创建任务id, b: 通过任务id创建截图); 5: 收到im截图信息后, 渲染出来


// WEBPACK FOOTER //
// ./src/store/index.js